// Lone Rider Make-filter + Sticky Cart sync + Sticky UI updates
// Extracted from snippets/product-template.liquid so it loads on every page
// (collection, home, etc.) and is available for quick shop modals.
(() => {
  /**
   * Lone Rider PDP Make-filter + Sticky Cart sync + Sticky UI updates
   * Sticky "Select variants" mode:
   *  - If main has > 1 option selector, sticky shows "Select variants"
   *  - ALSO if main has only 1 option selector AND make-filtering is actually enabled on that selector
   *    (Make exists in DOM on many products, so we ONLY use this path when make-filtering is truly active)
   *  - Button scrolls to .product-block--price
   */

  const MAKES = ['BMW', 'Ducati', 'Harley Davidson', 'Honda', 'Husqvarna', 'KTM', 'Kawasaki', 'Suzuki', 'Triumph', 'Yamaha'];

  const SELECTORS = {
    makeSelect: 'select[data-make-selector]',
    variantSelectRaw: 'select.js-variant-select, select[data-variant-input]',
    variantInputWrap: '.variant-input-wrap',

    stickyBar: '[data-sticky-cart-bar]',
    stickyForm: 'form[data-sticky-atc-form]',
    stickyPrice: '[data-sticky-price]',
    stickyCompare: '[data-sticky-compare-price]',
    stickyCompareWrap: '[data-sticky-compare-wrap]',
    stickyATC: 'button[data-add-to-cart]',
    stickyATCText: '[data-add-to-cart-text]',
    stickyImg: '.sticky-cart-bar__media img',
    stickyVariantId: 'select[name="id"], input[name="id"]',

    stickySelectVariantsBtn: '[data-sticky-select-variants]',
    stickyVariantsBlock: '.variant-wrapper, .variant-input-wrap, .make-input-wrap',

    mainScrollTarget: '.product-block--price'
  };

  // ---------- Money / strings ----------
  function formatMoney(centAmount) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(centAmount, theme.settings.moneyFormat);
    }
    return (centAmount / 100).toFixed(2);
  }

  function getStrings() {
    const strings = (window.theme && theme.strings) ? theme.strings : {};
    return {
      soldOut: strings.soldOut || 'Sold out',
      unavailable: strings.unavailable || 'Unavailable'
    };
  }

  // ---------- Text helpers ----------
  const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const makeToRegex = (make) => {
    const joined = make.split(/\s+/).map(escapeRegExp).join('[\\s-]+');
    return new RegExp(`\\b${joined}\\b`, 'i');
  };
  const MAKE_REGEXES = MAKES.map(makeToRegex);

  const textHasAnyMake = (t) => MAKE_REGEXES.some(rx => rx.test(String(t || '')));
  const textHasMake = (t, make) => makeToRegex(make).test(String(t || ''));

  const escapeHtml = (str) => String(str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  function parsePartsFromOptionText(text) {
    const rhs = (String(text || '').split('|')[1] || '').trim();
    return rhs.split('+').map(s => s.trim()).filter(Boolean);
  }

  function stripMakeFromText(text, make) {
    if (!make) return text;
    const rx = makeToRegex(make);
    const result = String(text || '').replace(rx, '').replace(/\s{2,}/g, ' ');
    return result.replace(/^\s+/, '');
  }

  // ---------- Variants JSON ----------
  function getVariantsFromPage() {
    const stickyJson = document.querySelector('[data-sticky-variants-json]');
    if (stickyJson) {
      try { return JSON.parse(stickyJson.textContent); } catch (e) {}
    }
    const mainJson = document.querySelector('textarea[data-variant-json]');
    if (mainJson) {
      try { return JSON.parse(mainJson.value || mainJson.textContent); } catch (e) {}
    }
    return [];
  }

  let ALL_VARIANTS = [];

  const NO_PRESELECT = (function() {
    const section = document.querySelector('[data-section-type="product"]');
    return !!(section && section.dataset.noPreselectVariants);
  })();

  const NO_MAKE_SELECTOR = (function() {
    const section = document.querySelector('[data-section-type="product"]');
    return !!(section && section.dataset.noMakeSelector);
  })();

  let __initPhase = true;

  // ---------- Container helpers ----------
  function isStickyContainer(el) {
    return !!(el && el.matches && el.matches(SELECTORS.stickyBar));
  }

  function getStickyContainer() {
    return document.querySelector(SELECTORS.stickyBar);
  }

  function getContainerProductId(container) {
    if (!container) return null;
    if (container.dataset && container.dataset.productId) return String(container.dataset.productId);
    const pidInput = container.querySelector('input[name="product-id"]');
    if (pidInput && pidInput.value) return String(pidInput.value);
    return null;
  }

  function getOtherContainer(currentContainer) {
    const sticky = getStickyContainer();

    if (isStickyContainer(currentContainer)) {
      const stickyPid = getContainerProductId(currentContainer);
      const productSections = Array.from(document.querySelectorAll('[data-section-type="product"]'));
      return productSections.find(s => getContainerProductId(s) === stickyPid) || productSections[0] || null;
    }

    const pid = getContainerProductId(currentContainer);
    if (sticky && getContainerProductId(sticky) === pid) return sticky;

    return null;
  }

  function findContainerFromEl(el) {
    const sticky = el?.closest?.(SELECTORS.stickyBar);
    if (sticky) return sticky;

    const sectionId = el?.getAttribute?.('data-section-id');
    if (sectionId) {
      const byId = document.getElementById(`ProductSection-${sectionId}`);
      if (byId && byId.contains(el)) return byId;
      // If not found by ID or doesn't contain el (section ID conflict between PDP and modal), fall through to closest()
    }

    return el?.closest?.('[data-section-type="product"]') || el?.closest?.('.product-section') || null;
  }

  // Returns the QuickShopHolder ancestor of an element (if any).
  function getModalHolder(el) {
    if (!el) return null;
    return el.closest('[id^="QuickShopHolder-"]') || null;
  }

  function dispatchChange(el) {
    if (!el) return;
    el.__lrInternalChange = true;
    el.dispatchEvent(new Event('change', { bubbles: true }));
    queueMicrotask(() => { el.__lrInternalChange = false; });
  }

  // ---------- Variant selects ----------
  function isVariantOptionSelect(el) {
    if (!el) return false;
    if (el.name === 'id') return false;
    return !!el.getAttribute('data-index');
  }

  function getVariantSelects(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll(SELECTORS.variantSelectRaw)).filter(isVariantOptionSelect);
  }

  function getVariantSelectByIndex(container, idx) {
    return getVariantSelects(container).find(s => s.getAttribute('data-index') === idx) || null;
  }

  function getFirstVariantSelect(container) {
    return getVariantSelectByIndex(container, 'option1') || getVariantSelects(container)[0] || null;
  }

  function syncSelectValueByIndex(sourceContainer, targetContainer, changedEl) {
    if (!sourceContainer || !targetContainer || !changedEl) return;

    if (changedEl.matches(SELECTORS.makeSelect)) {
      const targetMake = targetContainer.querySelector(SELECTORS.makeSelect);
      if (targetMake && targetMake.value !== changedEl.value) {
        targetMake.value = changedEl.value;
        // Notify the sticky bar so its availability (applyAvailability) recalculates
        if (isStickyContainer(targetContainer)) dispatchChange(targetMake);
      }
      return;
    }

    if (isVariantOptionSelect(changedEl)) {
      const idx = changedEl.getAttribute('data-index');
      if (!idx) return;

      const targetSel = getVariantSelectByIndex(targetContainer, idx);
      if (targetSel && targetSel.value !== changedEl.value) {
        targetSel.value = changedEl.value;
        // Notify the sticky bar so its availability (applyAvailability) recalculates
        if (isStickyContainer(targetContainer)) dispatchChange(targetSel);
      }
    }
  }

  // ---------- Custom dropdown (Safari-compatible make filtering) ----------
  function closeAllCustomDropdowns() {
    document.querySelectorAll('.lr-select.is-open').forEach(cd => cd.classList.remove('is-open'));
  }

  function buildCustomDropdown(selectEl) {
    if (!selectEl || selectEl.__lrCustomDropdown) return;
    const wrapper = selectEl.closest('.variant-input-wrap') || selectEl.parentElement;
    if (!wrapper) return;

    const cd = document.createElement('div');
    cd.className = 'lr-select';

    const trigger = document.createElement('div');
    trigger.className = 'lr-select__trigger';

    const labelEl = document.createElement('span');
    labelEl.className = 'lr-select__label';

    const arrow = document.createElement('span');
    arrow.className = 'lr-select__arrow';
    arrow.innerHTML = '<svg viewBox="0 0 10 6" width="10" height="6" aria-hidden="true"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>';

    trigger.appendChild(labelEl);
    trigger.appendChild(arrow);

    const list = document.createElement('ul');
    list.className = 'lr-select__list';

    // Build item list from native select options first (preserves order for present options).
    // Then supplement from ALL_VARIANTS in case VariantAvailability already stripped some
    // <option> elements before this script ran (happens when theme.js defer-loads first).
    const optIndex = selectEl.getAttribute('data-index'); // e.g. 'option1', 'option2'
    const itemMap = new Map();
    Array.from(selectEl.options).forEach(opt => itemMap.set(opt.value, { text: opt.text, img: opt.dataset.variantImage || null }));
    if (optIndex && ALL_VARIANTS.length) {
      ALL_VARIANTS.forEach(v => {
        const val = v[optIndex];
        if (val && !itemMap.has(val) && String(val).indexOf('DO NOT USE') === -1) {
          itemMap.set(val, { text: val, img: null });
        }
      });
    }
    itemMap.forEach((item, value) => {
      const li = document.createElement('li');
      li.className = 'lr-select__item';
      li.setAttribute('data-value', value);
      li.setAttribute('data-label', item.text);
      if (item.img) {
        const img = document.createElement('img');
        img.src = item.img;
        img.alt = '';
        img.className = 'lr-select__item-img';
        li.appendChild(img);
      }
      li.appendChild(document.createTextNode(item.text));
      // Patch: permanently hide Honda CRF1100L Africa Twin (31+38L)
      if (value === 'Honda CRF1100L Africa Twin (31+38L)') li.setAttribute('data-lr-force-hidden', 'true');
      list.appendChild(li);
    });

    cd.appendChild(trigger);
    cd.appendChild(list);

    // Hide native select but keep it in DOM for theme.Variants
    selectEl.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;overflow:hidden;';
    wrapper.insertBefore(cd, selectEl);

    selectEl.__lrCustomDropdown = cd;
    cd.__lrNativeSelect = selectEl;

    syncCustomDropdownDisplay(selectEl);

    trigger.addEventListener('click', e => {
      e.stopPropagation();
      const isOpen = cd.classList.contains('is-open');
      closeAllCustomDropdowns();
      if (!isOpen) cd.classList.add('is-open');
    });

    list.addEventListener('click', e => {
      const item = e.target.closest('.lr-select__item');
      if (!item || item.classList.contains('is-hidden')) return;
      const val = item.getAttribute('data-value');
      selectEl.value = val;
      syncCustomDropdownDisplay(selectEl);
      cd.classList.remove('is-open');
      // Plain change event — must NOT use dispatchChange() here because that sets
      // __lrInternalChange which causes our own listener to skip processing entirely.
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function syncCustomDropdownDisplay(selectEl) {
    const cd = selectEl && selectEl.__lrCustomDropdown;
    if (!cd) return;
    const labelEl = cd.querySelector('.lr-select__label');
    const items = Array.from(cd.querySelectorAll('.lr-select__item'));
    const currentVal = selectEl.value;

    items.forEach(i => i.classList.remove('is-selected'));
    const selected = items.find(i => i.getAttribute('data-value') === currentVal && !i.classList.contains('is-hidden'));
    if (selected) {
      selected.classList.add('is-selected');
      if (labelEl) labelEl.textContent = selected.textContent;
    } else if (labelEl) {
      labelEl.textContent = '';
    }
  }

  function filterCustomDropdown(selectEl, makeVal) {
    const cd = selectEl && selectEl.__lrCustomDropdown;
    if (!cd) return;
    const selectedMake = (makeVal || '').trim();
    const isUniversal = selectedMake && selectedMake.toLowerCase() === 'universal';
    const items = Array.from(cd.querySelectorAll('.lr-select__item'));

    // Use modal-scoped variants if available
    const holder = getModalHolder(selectEl);
    const effectiveVariants = (holder && holder.__lrVariants && holder.__lrVariants.length)
      ? holder.__lrVariants
      : ALL_VARIANTS;

    items.forEach(item => {
      const original = item.getAttribute('data-label') || '';
      const val = item.getAttribute('data-value') || '';
      if (!selectedMake) {
        item.classList.remove('is-hidden');
        item.textContent = original;
        return;
      }
      const match = isUniversal ? !textHasAnyMake(original) : textHasMake(original, selectedMake);
      if (!match) {
        item.classList.add('is-hidden');
        item.textContent = original;
        return;
      }
      // Also hide if no available variant has this option1 value
      const hasAvailable = !effectiveVariants.length || effectiveVariants.some(v => v.available && String(v.option1) === val);
      item.classList.toggle('is-hidden', !hasAvailable);
      item.textContent = (!isUniversal && hasAvailable) ? stripMakeFromText(original, selectedMake) : original;
    });

    // Patch: permanently hide Honda CRF1100L Africa Twin (31+38L) after all other filtering
    items.forEach(function(item) {
      if (item.getAttribute('data-lr-force-hidden') === 'true') item.classList.add('is-hidden');
    });

    // Auto-select first visible if current is hidden
    const currentVal = selectEl.value;
    const currentItem = items.find(i => i.getAttribute('data-value') === currentVal);
    if (!currentItem || currentItem.classList.contains('is-hidden')) {
      const firstVisible = items.find(i => !i.classList.contains('is-hidden'));
      if (firstVisible) {
        const targetVal = firstVisible.getAttribute('data-value');
        // Theme.js may have stripped this option from the native select — re-add it if missing
        if (!Array.from(selectEl.options).find(o => o.value === targetVal)) {
          const opt = document.createElement('option');
          opt.value = targetVal;
          opt.text = firstVisible.getAttribute('data-label') || targetVal;
          selectEl.appendChild(opt);
        }
        selectEl.value = targetVal;
      }
    }

    syncCustomDropdownDisplay(selectEl);
  }

  function restoreOptionState(selectEl) {
    const cd = selectEl && selectEl.__lrCustomDropdown;
    if (!cd) return;
    Array.from(cd.querySelectorAll('.lr-select__item')).forEach(item => {
      if (item.getAttribute('data-lr-force-hidden') === 'true') return; // Patch: keep permanently hidden
      item.classList.remove('is-hidden');
      item.textContent = item.getAttribute('data-label') || item.textContent;
    });
    syncCustomDropdownDisplay(selectEl);
  }

  // Returns all original option labels for a select (from custom dropdown if built, else native)
  function getOptionLabels(selectEl) {
    if (!selectEl) return [];
    const cd = selectEl.__lrCustomDropdown;
    if (cd) return Array.from(cd.querySelectorAll('.lr-select__item')).map(i => i.getAttribute('data-label') || '');
    return Array.from(selectEl.options).map(o => o.text);
  }

  function selectContainsMakeKeywords(selectEl) {
    return getOptionLabels(selectEl).some(textHasAnyMake);
  }

  function shouldEnableMakeFiltering(select1) {
    return getOptionLabels(select1).some(textHasAnyMake);
  }

  // ---------- Safer show/hide helpers ----------
  function setDisplay(el, visible) {
    if (!el) return;
    if (el.__lrOrigDisplay == null) el.__lrOrigDisplay = el.style.display || '';
    el.style.display = visible ? el.__lrOrigDisplay : 'none';
  }

  function getVariantWrapperFromSelect(selectEl) {
    if (!selectEl) return null;
    return selectEl.closest('.variant-wrapper');
  }

  function wrapperContainsMakeSelector(wrapper) {
    if (!wrapper) return false;
    return !!wrapper.querySelector(SELECTORS.makeSelect);
  }

  // ---------- UI visibility helpers ----------
  function setMakeUiVisible(container, visible) {
    if (!container) return;

    const makeSelect = container.querySelector(SELECTORS.makeSelect);
    if (!makeSelect) return;

    const makeWrap = makeSelect.closest('.make-input-wrap');
    setDisplay(makeWrap, visible);

    const makeLabel = container.querySelector(`label[for="${makeSelect.id}"]`);
    setDisplay(makeLabel, visible);
  }

  function setVariantControlsVisible(container, visible) {
    if (!container) return;

    const variantSelects = getVariantSelects(container);

    variantSelects.forEach(sel => {
      const wrapper = getVariantWrapperFromSelect(sel);

      // If Make + option are in same wrapper, DO NOT hide wrapper (or you hide Make too)
      if (wrapperContainsMakeSelector(wrapper)) {
        const inputWrap = sel.closest(SELECTORS.variantInputWrap);
        setDisplay(inputWrap, visible);

        const id = sel.id;
        if (id) {
          const label = container.querySelector(`label[for="${id}"]`);
          setDisplay(label, visible);
        }
        return;
      }

      setDisplay(wrapper, visible);
    });
  }

  function setAtcEnabled(container, enabled) {
    // For modal containers, scope ATC buttons to the container itself
    const scope = getModalHolder(container) || container || document.querySelector('[data-section-type="product"]');
    if (!scope) return;
    const btns = scope.querySelectorAll('button[data-add-to-cart]');
    btns.forEach(btn => {
      btn.disabled = !enabled;
      btn.classList.toggle('disabled', !enabled);
    });
  }

  // ---------- Initial slider rebuild on make-clear ----------
  // Mirrors theme.js updateVariantGallery, but reads from [data-initial-gallery-images]
  function rebuildInitialSlider(container) {
    const galleryEl = container.querySelector('[data-initial-gallery-images]');
    console.log('[LR] rebuildInitialSlider — galleryEl:', !!galleryEl);
    if (!galleryEl) return;

    let images;
    try { images = JSON.parse(galleryEl.textContent); } catch(e) { console.error('[LR] JSON parse error:', e); return; }
    console.log('[LR] images:', images ? images.length : 0);
    if (!images || !images.length) return;

    const mainSlider = container.querySelector('[data-product-photos]');
    const thumbSlider = container.querySelector('[data-product-thumbs]');
    const thumbScroller = container.querySelector('.product__thumbs--scroller');
    console.log('[LR] mainSlider:', !!mainSlider, 'thumbSlider:', !!thumbSlider, 'thumbScroller:', !!thumbScroller);
    if (!mainSlider) return;

    // Destroy any existing Flickity attached to the element (defensive — destroy can throw if internal state is stale)
    if (typeof Flickity !== 'undefined') {
      const flkty = Flickity.data(mainSlider);
      console.log('[LR] existing Flickity instance:', !!flkty);
      if (flkty) {
        try { flkty.destroy(); } catch(e) { console.warn('[LR] Flickity destroy failed (continuing):', e.message); }
      }
    }
    // Force-clean any leftover Flickity state on the element
    mainSlider.classList.remove('flickity-enabled', 'is-draggable');

    mainSlider.innerHTML = images.map(function(src, i) {
      return '<div class="product-main-slide' + (i === 0 ? ' starting-slide' : '') + '" data-index="' + i + '" tabindex="0">' +
        '<div data-product-image-main class="product-image-main">' +
        '<div class="image-wrap" style="height:0;padding-bottom:100%;">' +
        '<image-element><img src="' + src + '" class="product-featured-img image-element photoswipe__image" data-photoswipe-src="' + src + '" data-index="' + i + '" loading="eager"></image-element>' +
        '</div>' +
        '<button type="button" class="btn btn--no-animate btn--body btn--circle js-photoswipe__zoom product__photo-zoom">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><title>icon-search</title><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58ZM54 54 41.94 42"/></svg>' +
        '</button>' +
        '</div></div>';
    }).join('');

    if (thumbScroller) {
      thumbScroller.innerHTML = images.map(function(src, i) {
        return '<div class="product__thumb-item" data-index="' + i + '">' +
          '<a href="' + src + '" data-product-thumb class="product__thumb js-no-transition" data-index="' + i + '" data-id="initial-' + i + '">' +
          '<div class="image-wrap image-wrap__thumbnail" style="height:0;padding-bottom:100%;">' +
          '<img src="' + src + '" alt="">' +
          '</div></a></div>';
      }).join('');
    }
    if (thumbSlider) thumbSlider.classList.remove('hide');

    if (images.length > 1 && window.theme && theme.Slideshow) {
      try {
        const slideshow = new theme.Slideshow(mainSlider, {
          dragThreshold: 25,
          adaptiveHeight: true,
          initialIndex: 0,
          childNav: thumbSlider,
          childNavScroller: thumbScroller,
          childVertical: thumbSlider ? thumbSlider.dataset.position === 'beside' : false,
          wrapAround: true
        });
        console.log('[LR] new Slideshow created:', !!slideshow);
      } catch(e) { console.error('[LR] Slideshow init error:', e); }
    } else {
      const singleSlide = mainSlider.querySelector('.product-main-slide');
      if (singleSlide) singleSlide.classList.add('is-selected');
    }

    // Re-bind hover zoom listeners to the freshly rebuilt slides
    if (typeof window.__lrInitProductImageZoom === 'function') window.__lrInitProductImageZoom();
  }

  // ---------- Make dropdown option pruning ----------
  function updateMakeOptionsVisibility(makeSelect, select1) {
    if (!makeSelect || !select1) return;

    const cd = makeSelect.__lrCustomDropdown;
    const option1Texts = getOptionLabels(select1);
    const universalCount = option1Texts.filter(t => !textHasAnyMake(t)).length;
    const countMatchesFor = (make) => option1Texts.filter(t => textHasMake(t, make)).length;

    // Use modal-scoped variants if available
    const holder = getModalHolder(makeSelect);
    const effectiveVariants = (holder && holder.__lrVariants && holder.__lrVariants.length)
      ? holder.__lrVariants
      : ALL_VARIANTS;

    // Returns true only if at least one available variant exists for this make.
    // Makes whose every variant is sold out are hidden from the Make dropdown entirely.
    const hasAvailableVariantFor = (make) => {
      if (!effectiveVariants.length) return true; // no data yet — don't hide
      if (make.toLowerCase() === 'universal') {
        return effectiveVariants.some(v => v.available && !textHasAnyMake(String(v.option1 || '')));
      }
      return effectiveVariants.some(v => v.available && textHasMake(String(v.option1 || ''), make));
    };

    if (cd) {
      Array.from(cd.querySelectorAll('.lr-select__item')).forEach(item => {
        const val = (item.getAttribute('data-value') || '').trim();
        if (!val) { item.classList.remove('is-hidden'); return; }

        if (val.toLowerCase() === 'universal') {
          const hide = universalCount === 0 || !hasAvailableVariantFor('universal');
          item.classList.toggle('is-hidden', hide);
          if (hide && (makeSelect.value || '').trim().toLowerCase() === 'universal') makeSelect.value = '';
          return;
        }

        if (!MAKES.includes(val)) { item.classList.remove('is-hidden'); return; }

        const hide = countMatchesFor(val) === 0 || !hasAvailableVariantFor(val);
        item.classList.toggle('is-hidden', hide);
        if (hide && makeSelect.value === val) makeSelect.value = '';
      });
      syncCustomDropdownDisplay(makeSelect);
    } else {
      // fallback: native select
      Array.from(makeSelect.options).forEach(opt => {
        const val = (opt.value || '').trim();
        if (!val) { opt.hidden = false; opt.disabled = false; return; }
        if (val.toLowerCase() === 'universal') {
          const hide = universalCount === 0 || !hasAvailableVariantFor('universal');
          opt.hidden = hide; opt.disabled = hide;
          if (hide && (makeSelect.value || '').trim().toLowerCase() === 'universal') makeSelect.value = '';
          return;
        }
        if (!MAKES.includes(val)) { opt.hidden = false; opt.disabled = false; return; }
        const hide = countMatchesFor(val) === 0 || !hasAvailableVariantFor(val);
        opt.hidden = hide; opt.disabled = hide;
        if (hide && makeSelect.value === val) makeSelect.value = '';
      });
    }
  }

  function autoSelectSingleMake(makeSelect) {
    if (!makeSelect) return false;

    const cd = makeSelect.__lrCustomDropdown;
    let visibleMakeItems, hasVisibleUniversal;

    if (cd) {
      const items = Array.from(cd.querySelectorAll('.lr-select__item'));
      visibleMakeItems = items.filter(i => {
        const val = (i.getAttribute('data-value') || '').trim();
        return val && !i.classList.contains('is-hidden') && val.toLowerCase() !== 'universal';
      });
      hasVisibleUniversal = items.some(i => {
        const val = (i.getAttribute('data-value') || '').trim();
        return val && !i.classList.contains('is-hidden') && val.toLowerCase() === 'universal';
      });

      if (visibleMakeItems.length === 1 && !hasVisibleUniversal) {
        const onlyVal = visibleMakeItems[0].getAttribute('data-value');
        if (makeSelect.value !== onlyVal) {
          makeSelect.value = onlyVal;
          syncCustomDropdownDisplay(makeSelect);
          return true;
        }
      }
    } else {
      const opts = Array.from(makeSelect.options);
      visibleMakeItems = opts.filter(o => o.value && !o.hidden && !o.disabled && o.value.toLowerCase() !== 'universal');
      hasVisibleUniversal = opts.some(o => o.value && !o.hidden && !o.disabled && o.value.trim().toLowerCase() === 'universal');

      if (visibleMakeItems.length === 1 && !hasVisibleUniversal) {
        const onlyMake = visibleMakeItems[0];
        if (makeSelect.value !== onlyMake.value) {
          makeSelect.value = onlyMake.value;
          return true;
        }
      }
    }
    return false;
  }

  function filterSelectOptions(selectEl, makeVal) {
    filterCustomDropdown(selectEl, makeVal);
  }

  // Filter a custom dropdown to only show values that exist in at least one variant
  // where all prior option values match the current selections.
  // e.g. for option2 dropdown: only show values where variant.option1 === currently selected option1
  function filterCustomDropdownByPriorSelections(selectEl, optionNumber, priorSelections) {
    const cd = selectEl && selectEl.__lrCustomDropdown;
    if (!cd) return;

    // Use modal-scoped variants if available
    const holder = getModalHolder(selectEl);
    const effectiveVariants = (holder && holder.__lrVariants && holder.__lrVariants.length)
      ? holder.__lrVariants
      : ALL_VARIANTS;

    if (!effectiveVariants || !effectiveVariants.length) return;

    const existingValues = new Set();
    effectiveVariants.forEach(function(v) {
      if (!v.available) return;
      for (let i = 0; i < priorSelections.length; i++) {
        const prior = priorSelections[i];
        if (prior && String(v['option' + (i + 1)]) !== String(prior)) return;
      }
      const val = v['option' + optionNumber];
      if (val) existingValues.add(val);
    });

    const items = Array.from(cd.querySelectorAll('.lr-select__item'));
    items.forEach(function(item) {
      const val = item.getAttribute('data-value');
      if (val === '') return; // Never hide placeholder items
      const hide = !existingValues.has(val);
      item.classList.toggle('is-hidden', hide);
    });

    // Auto-select first visible if current selection is now hidden.
    // Exception: never auto-select for no-make-selector products during init phase.
    const currentItem = items.find(i => i.getAttribute('data-value') === selectEl.value);
    if (!currentItem || currentItem.classList.contains('is-hidden')) {
      if (!(NO_MAKE_SELECTOR && __initPhase)) {
        const firstVisible = items.find(i => !i.classList.contains('is-hidden'));
        if (firstVisible) selectEl.value = firstVisible.getAttribute('data-value');
      }
    }

    syncCustomDropdownDisplay(selectEl);
  }

  // ---------- WITB output (main only) ----------
  function updateWitb(container) {
    if (isStickyContainer(container)) return;
    // WITB only applies to the main PDP, not quick shop modals
    if (getModalHolder(container)) return;

    const incl = document.getElementById('witb_incl_list');
    const excl = document.getElementById('witb_excl_list');
    if (!incl || !excl || !container) return;

    const makeSelect = container.querySelector(SELECTORS.makeSelect);
    const select1 = getFirstVariantSelect(container);
    if (!makeSelect || !select1) return;

    const makeVal = (makeSelect.value || '').trim();
    if (!makeVal) { incl.innerHTML = ''; excl.innerHTML = ''; return; }

    const rawText = select1.options[select1.selectedIndex]?.text || '';
    const selectedText = stripMakeFromText(rawText, makeVal);
    const parts = parsePartsFromOptionText(selectedText);

    const includeItems = [];
    const excludeItems = [];
    const noWord = /\bno\b/i;

    parts.forEach(item => (noWord.test(item) ? excludeItems : includeItems).push(item));
    incl.innerHTML = includeItems.map(i => `<li class="product__items">${escapeHtml(i)}</li>`).join('');
    excl.innerHTML = excludeItems.map(i => `<li class="product__items">${escapeHtml(i)}</li>`).join('');
  }

  // ---------- Sticky UI ----------
  function getSelectedOptionsFromContainer(container) {
    const selects = getVariantSelects(container);

    selects.sort((a, b) => {
      const ai = parseInt((a.getAttribute('data-index') || '').replace('option', ''), 10) || 0;
      const bi = parseInt((b.getAttribute('data-index') || '').replace('option', ''), 10) || 0;
      return ai - bi;
    });

    return selects.map(s => s.value);
  }

  function findVariantByOptions(selectedOptions) {
    if (!selectedOptions || !selectedOptions.length || !ALL_VARIANTS || !ALL_VARIANTS.length) return null;

    return ALL_VARIANTS.find(v => {
      if (!v || !v.options || v.options.length !== selectedOptions.length) return false;
      for (let i = 0; i < selectedOptions.length; i++) {
        if (String(v.options[i]) !== String(selectedOptions[i])) return false;
      }
      return true;
    }) || null;
  }

  function updateStickyButtonState(stickyEl, variant) {
    const btn = stickyEl.querySelector(SELECTORS.stickyATC);
    const btnText = stickyEl.querySelector(SELECTORS.stickyATCText);
    if (!btn) return;

    const strings = getStrings();

    // If main product requires a make but none is selected, keep ATC disabled regardless of panel state
    const mainSection = getOtherContainer(stickyEl);
    if (mainSection) {
      const mainMake = mainSection.querySelector(SELECTORS.makeSelect);
      const mainSelect1 = getFirstVariantSelect(mainSection);
      if (mainMake && mainSelect1 && shouldEnableMakeFiltering(mainSelect1) && !mainMake.value) {
        btn.disabled = true;
        btn.classList.add('disabled');
        if (btnText) btnText.textContent = strings.unavailable;
        return;
      }
    }

    // If the above panel is closed, the button opens it — label accordingly.
    const above = stickyEl.querySelector('.sticky-cart-bar__above');
    if (above && !above.classList.contains('is-open')) {
      if (btnText) btnText.textContent = 'Select Variant';
      btn.disabled = false;
      btn.classList.remove('disabled');
      return;
    }

    if (variant) {
      if (variant.available) {
        btn.disabled = false;
        btn.classList.remove('disabled');
        if (btnText) {
          const defaultText = btnText.dataset.defaultText || 'Add to cart';
          btnText.textContent = defaultText;
        }
      } else {
        btn.disabled = true;
        btn.classList.add('disabled');
        if (btnText) btnText.textContent = strings.soldOut;
      }
    } else {
      btn.disabled = true;
      btn.classList.add('disabled');
      if (btnText) btnText.textContent = strings.unavailable;
    }
  }

  function getVariantForSticky(stickyEl) {
    if (stickyEl && stickyEl.__lrSelectVariantsMode) {
      const main = getOtherContainer(stickyEl);
      if (!main) return null;
      return findVariantByOptions(getSelectedOptionsFromContainer(main));
    }
    const options = getSelectedOptionsFromContainer(stickyEl);
    if (!options.length && ALL_VARIANTS && ALL_VARIANTS.length) return ALL_VARIANTS[0];
    return findVariantByOptions(options);
  }

  function updateStickyUI(stickyEl) {
    if (!stickyEl || !isStickyContainer(stickyEl)) return;

    if (!ALL_VARIANTS || !ALL_VARIANTS.length) ALL_VARIANTS = getVariantsFromPage();

    const variant = getVariantForSticky(stickyEl);

    updateStickyButtonState(stickyEl, variant);
    if (!variant) return;

    stickyEl.querySelectorAll(SELECTORS.stickyPrice).forEach(function(el) { el.innerHTML = formatMoney(variant.price); });

    const compareEl = stickyEl.querySelector(SELECTORS.stickyCompare);
    const compareWrap = stickyEl.querySelector(SELECTORS.stickyCompareWrap);
    const onSale = variant.compare_at_price && (variant.compare_at_price > variant.price);

    if (compareEl) {
      compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
      compareEl.style.display = onSale ? '' : 'none';
    }
    if (compareWrap) compareWrap.style.display = onSale ? '' : 'none';

    const imgEl = stickyEl.querySelector(SELECTORS.stickyImg);
    const vImg = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
    if (imgEl && vImg) {
      const url = vImg + (vImg.indexOf('?') > -1 ? '&' : '?') + 'width=140';
      if (imgEl.src !== url) imgEl.src = url;
    }

    const idEl = stickyEl.querySelector(SELECTORS.stickyVariantId);
    if (idEl && String(idEl.value) !== String(variant.id)) {
      idEl.value = String(variant.id);
    }
  }

  // ---------- Sticky "Select variants" mode logic (FIXED) ----------
  function shouldUseSelectVariantsMode() {
    return false; // sticky bar now shows variant selectors inline above the bar
    const sticky = getStickyContainer();
    const main = sticky ? getOtherContainer(sticky) : document.querySelector('[data-section-type="product"]');
    if (!main) return false;

    const optionSelects = getVariantSelects(main);
    const optionSelectCount = optionSelects.length;

    // Rule 1: multiple option selectors => force select-variants mode
    if (optionSelectCount > 1) return true;

    // Rule 2 (the Make-driven case): only if make-filtering is actually enabled on option1
    // (Make selector may exist on other products but isn't used)
    const select1 = optionSelects[0] || null;
    const makeFilteringEnabled = !!(select1 && shouldEnableMakeFiltering(select1));

    if (optionSelectCount === 1 && makeFilteringEnabled) return true;

    return false;
  }

  function ensureStickySelectVariantsButton(stickyEl) {
    if (!stickyEl) return null;

    let btn = stickyEl.querySelector(SELECTORS.stickySelectVariantsBtn);
    if (btn) return btn;

    const atcBtn = stickyEl.querySelector(SELECTORS.stickyATC);
    const form = stickyEl.querySelector(SELECTORS.stickyForm) || (atcBtn ? atcBtn.closest('form') : null);

    btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-sticky-select-variants', '');
    btn.className = (atcBtn && atcBtn.className) ? atcBtn.className : 'btn';
    btn.textContent = 'Select variants';

    if (atcBtn && atcBtn.parentNode) {
      atcBtn.parentNode.insertBefore(btn, atcBtn);
    } else if (form) {
      form.appendChild(btn);
    } else {
      stickyEl.appendChild(btn);
    }

    return btn;
  }

  function scrollToMainVariants(stickyEl) {
    const main = stickyEl ? getOtherContainer(stickyEl) : null;
    const target = (main && main.querySelector(SELECTORS.mainScrollTarget)) || document.querySelector(SELECTORS.mainScrollTarget);

    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const focusEl =
      (main && main.querySelector(SELECTORS.makeSelect)) ||
      (main && main.querySelector(SELECTORS.variantSelectRaw));
    if (focusEl && focusEl.focus) {
      setTimeout(() => focusEl.focus({ preventScroll: true }), 350);
    }
  }

  function enableStickySelectVariantsMode(stickyEl) {
    if (!stickyEl) return;

    stickyEl.__lrSelectVariantsMode = true;

    stickyEl.querySelectorAll(SELECTORS.stickyVariantsBlock).forEach(el => setDisplay(el, false));
    stickyEl.querySelectorAll('label.variant__label').forEach(l => setDisplay(l, false));

    const form = stickyEl.querySelector(SELECTORS.stickyForm);
    const atcBtn = stickyEl.querySelector(SELECTORS.stickyATC);

    if (atcBtn) {
      setDisplay(atcBtn, false);
      atcBtn.disabled = true;
    }

    if (form && !form.__lrSelectVariantsSubmitBlocked) {
      form.__lrSelectVariantsSubmitBlocked = true;
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollToMainVariants(stickyEl);
      }, true);
    }

    const svBtn = ensureStickySelectVariantsButton(stickyEl);
    if (svBtn) {
      setDisplay(svBtn, true);
      if (!svBtn.__lrBoundClick) {
        svBtn.__lrBoundClick = true;
        svBtn.addEventListener('click', () => scrollToMainVariants(stickyEl));
      }
    }

    updateStickyUI(stickyEl);
  }

  function disableStickySelectVariantsMode(stickyEl) {
    if (!stickyEl) return;

    stickyEl.__lrSelectVariantsMode = false;

    stickyEl.querySelectorAll(SELECTORS.stickyVariantsBlock).forEach(el => setDisplay(el, true));
    stickyEl.querySelectorAll('label.variant__label').forEach(l => setDisplay(l, true));

    const atcBtn = stickyEl.querySelector(SELECTORS.stickyATC);
    if (atcBtn) {
      setDisplay(atcBtn, true);
      atcBtn.disabled = false;
    }

    const svBtn = stickyEl.querySelector(SELECTORS.stickySelectVariantsBtn);
    if (svBtn) setDisplay(svBtn, false);

    updateStickyUI(stickyEl);
  }

  function configureStickyVariantUX() {
    const sticky = getStickyContainer();
    if (!sticky) return;

    if (shouldUseSelectVariantsMode()) enableStickySelectVariantsMode(sticky);
    else disableStickySelectVariantsMode(sticky);
  }

  // ---------- Sticky Ajax ATC (Cart Drawer) ----------
  function initStickyAjaxATC() {
    const sticky = getStickyContainer();
    if (!sticky) return;
    if (sticky.__lrSelectVariantsMode) return;

    const form = sticky.querySelector(SELECTORS.stickyForm);
    if (!form || form.__lrAjaxBound) return;
    form.__lrAjaxBound = true;

    const btn = sticky.querySelector(SELECTORS.stickyATC);

    function setLoading(isLoading) {
      if (!btn) return;
      btn.classList.toggle('is-loading', !!isLoading);
      btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function dispatchAdded(addedItem) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: addedItem }
      }));
    }

    form.addEventListener('submit', (e) => {
      if (btn && btn.disabled) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      setLoading(true);

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData,
        credentials: 'same-origin'
      })
        .then((res) => {
          if (!res.ok) return res.json().then((err) => { throw err; });
          return res.json();
        })
        .then((addedItem) => dispatchAdded(addedItem))
        .catch((err) => console.error('Sticky cart add error:', err))
        .finally(() => setLoading(false));
    }, true);
  }

  // ---------- Rack selection (rack_selection tagged products) ----------

  function isRackSelectionContainer(container) {
    if (!container) return false;
    const makeSelect = container.querySelector(SELECTORS.makeSelect);
    return !!(makeSelect && makeSelect.dataset.rackSelection);
  }

  // Builds the "Do you need a rack?" dropdown above the make wrapper.
  // Called once during initAll for each rack_selection container.
  function buildRackQuestion(container) {
    if (!container || isStickyContainer(container)) return;
    if (container.__lrRackQuestion) return;

    const makeSelect = container.querySelector(SELECTORS.makeSelect);
    if (!makeSelect || !makeSelect.dataset.rackSelection) return;

    const makeWrap = makeSelect.closest('.make-input-wrap');
    if (!makeWrap) return;

    const ARROW = '<svg viewBox="0 0 10 6" width="10" height="6" aria-hidden="true"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>';

    const questionEl = document.createElement('div');
    questionEl.className = 'lr-rack-question';
    questionEl.innerHTML =
      '<label class="variant__label">Do you need a rack?</label>' +
      '<div class="lr-select lr-rack-select">' +
        '<div class="lr-select__trigger">' +
          '<span class="lr-select__label"></span>' +
          '<span class="lr-select__arrow">' + ARROW + '</span>' +
        '</div>' +
        '<ul class="lr-select__list">' +
          '<li class="lr-select__item" data-value="no" data-label="No \u2014 I already have a rack installed">No \u2014 I already have a rack installed</li>' +
          '<li class="lr-select__item" data-value="yes" data-label="Yes">Yes</li>' +
        '</ul>' +
      '</div>' +
      '<div class="lr-rack-fitment-link" style="display:none;margin-top:10px;">' +
        '<a href="https://lonerider.com/pages/motobags-rack-fitment?lnset=1" target="_blank" rel="noopener" class="lr-rack-fitment-anchor">Check rack fitment guide</a>' +
      '</div>';

    makeWrap.after(questionEl);
    container.__lrRackQuestion = questionEl;

    // If preselectMakeFromVariantUrl already resolved the answer, show it
    syncRackQuestionDisplay(container);

    const cd = questionEl.querySelector('.lr-rack-select');
    const trigger = cd.querySelector('.lr-select__trigger');
    const list = cd.querySelector('.lr-select__list');

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = cd.classList.contains('is-open');
      closeAllCustomDropdowns();
      if (!isOpen) cd.classList.add('is-open');
    });

    list.addEventListener('click', function(e) {
      const item = e.target.closest('.lr-select__item');
      if (!item || item.classList.contains('is-disabled')) return;
      const answer = item.getAttribute('data-value');
      const ms = container.querySelector(SELECTORS.makeSelect);

      // Use modal-scoped variants when inside a quick shop holder
      const holder = getModalHolder(container);
      const effectiveVariants = (holder && holder.__lrVariants && holder.__lrVariants.length)
        ? holder.__lrVariants
        : ALL_VARIANTS;

      if (answer === 'no') {
        // Force Make to "Universal"
        if (ms) { ms.value = 'Universal'; syncCustomDropdownDisplay(ms); }
      } else if (answer === 'yes') {
        const firstMakeVariant = effectiveVariants.find(function(v) {
          return v.available && textHasAnyMake(String(v.options && v.options[0] || ''));
        });
        if (firstMakeVariant && ms) {
          const opt1 = String(firstMakeVariant.options[0] || '');
          const matchedMake = MAKES.find(function(make) { return textHasMake(opt1, make); });
          if (matchedMake) { ms.value = matchedMake; syncCustomDropdownDisplay(ms); }
        }
      }

      cd.classList.remove('is-open');
      applyRackSelectionState(container);
      configureStickyVariantUX();
      const sticky = getStickyContainer();
      if (sticky) updateStickyUI(sticky);
    });
  }

  function syncRackQuestionDisplay(container) {
    const questionEl = container && container.__lrRackQuestion;
    if (!questionEl) return;
    const cd = questionEl.querySelector('.lr-rack-select');
    if (!cd) return;
    const labelEl = cd.querySelector('.lr-select__label');
    const items = Array.from(cd.querySelectorAll('.lr-select__item'));
    items.forEach(function(i) { i.classList.remove('is-selected'); });
    const active = items.find(function(i) { return i.getAttribute('data-value') === container.__lrRackAnswer; });
    if (active) {
      // Only mark as selected in the list if the item is not disabled
      if (!active.classList.contains('is-disabled')) active.classList.add('is-selected');
      if (labelEl) labelEl.textContent = active.getAttribute('data-label');
    } else if (labelEl) {
      labelEl.textContent = '';
    }
    // Show rack fitment link only when Universal (No) is selected
    const fitmentLink = questionEl.querySelector('.lr-rack-fitment-link');
    if (fitmentLink) fitmentLink.style.display = container.__lrRackAnswer === 'no' ? '' : 'none';
  }

  // Applies variant picker state for a rack_selection container.
  // Make is always visible. Rack answer is derived from the current Make value
  // so the two dropdowns stay in sync regardless of which was changed.
  function applyRackSelectionState(container) {
    if (container.__makeApplying) return;
    container.__makeApplying = true;

    try {
      const makeSelect = container.querySelector(SELECTORS.makeSelect);
      const selects = getVariantSelects(container);
      const select1 = selects[0];
      if (!makeSelect || !select1) return;

      // Make stays visible — this is the primary selector
      setMakeUiVisible(container, true);
      updateMakeOptionsVisibility(makeSelect, select1);
      if (!makeSelect.value) autoSelectSingleMake(makeSelect);

      const makeVal = (makeSelect.value || '').trim();
      const isUniversal = makeVal.toLowerCase() === 'universal';

      // Derive rack answer from Make and keep the rack dropdown in sync
      if (makeVal) {
        container.__lrRackAnswer = isUniversal ? 'no' : 'yes';
        syncRackQuestionDisplay(container);
      }

      const hasMake = !!makeVal;
      setVariantControlsVisible(container, hasMake);
      setAtcEnabled(container, hasMake);

      if (!hasMake) {
        updateWitb(container);
        return;
      }

      // Filter option1 by the selected make (Universal shows product-only sizes)
      filterSelectOptions(select1, makeVal);

      // Additional options: filter by make keywords if present, otherwise filter by exact prior selections
      for (var i = 1; i < selects.length; i++) {
        if (selectContainsMakeKeywords(selects[i])) filterSelectOptions(selects[i], makeVal);
        else filterCustomDropdownByPriorSelections(selects[i], i + 1, selects.slice(0, i).map(function(s) { return s.value; }));
      }

      if (!(NO_PRESELECT && __initPhase)) {
        queueMicrotask(function() {
          selects.forEach(function(sel) { dispatchChange(sel); });
        });
      }

      updateWitb(container);
      if (isStickyContainer(container)) updateStickyUI(container);

    } finally {
      queueMicrotask(function() { container.__makeApplying = false; });
    }
  }

  // ---------- Main apply ----------
  function applyForContainer(container) {
    if (!container) return;

    if (isStickyContainer(container) && container.__lrSelectVariantsMode) {
      updateStickyUI(container);
      return;
    }

    // rack_selection products have their own apply logic (non-sticky only)
    if (!isStickyContainer(container) && isRackSelectionContainer(container)) {
      applyRackSelectionState(container);
      const sticky = getStickyContainer();
      if (sticky) updateStickyUI(sticky);
      return;
    }

    const makeSelect = container.querySelector(SELECTORS.makeSelect);
    const selects = getVariantSelects(container);
    const select1 = selects[0];
    if (!makeSelect || !select1) return;

    if (container.__makeApplying) return;
    container.__makeApplying = true;

    try {
      if (NO_MAKE_SELECTOR) {
        setMakeUiVisible(container, false);
        setVariantControlsVisible(container, true);

        // During init, force all selects back to empty (placeholder) so theme.js
        // cannot find a matching variant and enable ATC.
        if (__initPhase) {
          selects.forEach(sel => {
            // Ensure the custom dropdown has a placeholder item (VariantAvailability
            // may have stripped the value="" option from the native select before build).
            const cd = sel.__lrCustomDropdown;
            if (cd) {
              const list = cd.querySelector('.lr-select__list');
              if (list && !list.querySelector('.lr-select__item[data-value=""]')) {
                const wrap = sel.closest('[data-handle]');
                const rawHandle = wrap ? wrap.getAttribute('data-handle') : 'option';
                const optName = rawHandle.split('-').map(function(w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
                const placeholder = document.createElement('li');
                placeholder.className = 'lr-select__item lr-select__item--placeholder';
                placeholder.setAttribute('data-value', '');
                placeholder.textContent = 'Choose ' + optName;
                list.insertBefore(placeholder, list.firstChild);
              }
            }

            sel.value = '';
            syncCustomDropdownDisplay(sel);
          });
        }

        for (let i = 0; i < selects.length; i++) {
          const priorVals = selects.slice(0, i).map(s => s.value);
          filterCustomDropdownByPriorSelections(selects[i], i + 1, priorVals);
        }

        const anyEmpty = selects.some(sel => !sel.value);
        if (anyEmpty && !isStickyContainer(container)) setAtcEnabled(container, false);

        if (!isStickyContainer(container) && !__initPhase) {
          queueMicrotask(() => {
            const s1 = getVariantSelectByIndex(container, 'option1');
            const s2 = getVariantSelectByIndex(container, 'option2');
            const s3 = getVariantSelectByIndex(container, 'option3');
            if (s1) dispatchChange(s1);
            if (s2) dispatchChange(s2);
            if (s3) dispatchChange(s3);
          });
        }

        updateWitb(container);
        if (isStickyContainer(container)) updateStickyUI(container);
        return;
      }

      const enableMake = shouldEnableMakeFiltering(select1);

      if (!enableMake) {
        setMakeUiVisible(container, false);
        setVariantControlsVisible(container, true);

        // Filter each dropdown to only show options that have at least one available variant.
        // For cascading selects (option2, option3) respect prior selections.
        // This prevents sold-out options from ever being visible or selectable.
        for (let i = 0; i < selects.length; i++) {
          const priorVals = selects.slice(0, i).map(s => s.value);
          filterCustomDropdownByPriorSelections(selects[i], i + 1, priorVals);
        }

        if (!isStickyContainer(container) && !(NO_PRESELECT && __initPhase)) {
          queueMicrotask(() => {
            const s1 = getVariantSelectByIndex(container, 'option1');
            const s2 = getVariantSelectByIndex(container, 'option2');
            const s3 = getVariantSelectByIndex(container, 'option3');
            if (s1) dispatchChange(s1);
            if (s2) dispatchChange(s2);
            if (s3) dispatchChange(s3);
          });
        }

        updateWitb(container);
        if (isStickyContainer(container)) updateStickyUI(container);
        return;
      }

      setMakeUiVisible(container, true);
      updateMakeOptionsVisibility(makeSelect, select1);

      if (!makeSelect.value && !(NO_PRESELECT && __initPhase)) autoSelectSingleMake(makeSelect);

      const makeVal = (makeSelect.value || '').trim();
      const hasMakeSelected = !!makeVal;
      const isUniversalSelected = makeVal.toLowerCase() === 'universal';
      const motocaseUniversal = !!(makeSelect.dataset && makeSelect.dataset.motocaseUniversal);

      setVariantControlsVisible(container, hasMakeSelected);
      setAtcEnabled(container, hasMakeSelected);

      if (!hasMakeSelected && !isStickyContainer(container) && !getModalHolder(container)) {
        if (!__initPhase) {
          const _params = new URLSearchParams(window.location.search);
          if (_params.has('variant')) {
            _params.delete('variant');
            const _qs = _params.toString();
            window.history.replaceState({}, '', window.location.pathname + (_qs ? '?' + _qs : '') + window.location.hash);
          }
          rebuildInitialSlider(container);
        }
        const _sticky = getStickyContainer();
        if (_sticky) setAtcEnabled(_sticky, false);
      }

      // For motocase: hide only option1 (bike selector) when Universal is selected,
      // keep all other options (e.g. size) visible
      if (motocaseUniversal) {
        const sel1 = getVariantSelectByIndex(container, 'option1');
        const inputWrap1 = sel1 && sel1.closest(SELECTORS.variantInputWrap);
        const label1 = sel1 && sel1.id && container.querySelector('label[for="' + sel1.id + '"]');
        if (inputWrap1) inputWrap1.classList.toggle('lr-offscreen', isUniversalSelected);
        if (label1) label1.classList.toggle('lr-offscreen', isUniversalSelected);

        // Remove the gap between wrappers when the bike selector is hidden
        const sel2 = getVariantSelectByIndex(container, 'option2');
        const wrapper2 = sel2 && sel2.closest('.variant-wrapper');
        if (wrapper2) wrapper2.classList.toggle('lr-no-top-margin', isUniversalSelected);
      }

      if (hasMakeSelected) filterSelectOptions(select1, makeVal);
      else restoreOptionState(select1);

      for (let i = 1; i < selects.length; i++) {
        const sel = selects[i];
        if (!hasMakeSelected) { restoreOptionState(sel); continue; }
        if (selectContainsMakeKeywords(sel)) filterSelectOptions(sel, makeVal);
        else filterCustomDropdownByPriorSelections(sel, i + 1, selects.slice(0, i).map(s => s.value));
      }

      if (!isStickyContainer(container) && !(NO_PRESELECT && __initPhase)) {
        queueMicrotask(() => {
          const s1 = getVariantSelectByIndex(container, 'option1');
          const s2 = getVariantSelectByIndex(container, 'option2');
          const s3 = getVariantSelectByIndex(container, 'option3');
          if (s1) dispatchChange(s1);
          if (s2) dispatchChange(s2);
          if (s3) dispatchChange(s3);
        });
      }

      updateWitb(container);
      if (isStickyContainer(container)) updateStickyUI(container);

    } finally {
      queueMicrotask(() => { container.__makeApplying = false; });
    }
  }

  // ---------- URL variant → Make preselection ----------
  // Uses ALL_VARIANTS JSON (always correct) + ?variant= ID.
  // Also explicitly sets the variant select values so CDN-cached pages
  // (which may not have the correct selected="selected" attributes) work correctly.
  // force=true bypasses the makeSelect.value guard so a delayed re-apply
  // can override whatever theme.Variants init may have reset.
  function preselectMakeFromVariantUrl(force) {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (!variantId) return;

    if (!ALL_VARIANTS.length) ALL_VARIANTS = getVariantsFromPage();

    const variant = ALL_VARIANTS.find(v => String(v.id) === String(variantId));
    if (!variant || !variant.options || !variant.options.length) return;

    const option1Value = String(variant.options[0] || '');

    document.querySelectorAll(SELECTORS.makeSelect).forEach(makeSelect => {
      if (!force && makeSelect.value) return; // skip if already set (unless forcing)

      const container = findContainerFromEl(makeSelect);
      if (!container) return;

      const select1 = getFirstVariantSelect(container);
      if (!select1 || !shouldEnableMakeFiltering(select1)) return;

      // Explicitly set each variant select to match the URL variant
      // (fixes CDN-cached pages where selected="selected" may be missing/wrong)
      const selects = getVariantSelects(container);
      selects.forEach((sel, i) => {
        const optVal = String(variant.options[i] || '');
        if (optVal && sel.value !== optVal) sel.value = optVal;
      });

      // Infer Make from option1 value
      const matchedMake = MAKES.find(make => textHasMake(option1Value, make));
      if (matchedMake) {
        makeSelect.value = matchedMake;
      } else if (!textHasAnyMake(option1Value)) {
        // No make keyword → Universal
        const universalOpt = Array.from(makeSelect.options).find(
          o => o.value.trim().toLowerCase() === 'universal'
        );
        if (universalOpt) makeSelect.value = universalOpt.value;
      }

      // Sync variant selects custom dropdown display too
      selects.forEach(sel => syncCustomDropdownDisplay(sel));
      syncCustomDropdownDisplay(makeSelect);

      // For rack_selection products: auto-select rack answer based on resolved make
      if (makeSelect.dataset.rackSelection) {
        const resolvedMake = (makeSelect.value || '').trim().toLowerCase();
        if (resolvedMake === 'universal' || resolvedMake === '') {
          container.__lrRackAnswer = 'no';
        }
        syncRackQuestionDisplay(container);
      }
    });
  }

  // Re-apply Make selection in force mode, then re-run applyForContainer.
  // Called after a delay so theme.Variants async init can't wipe our state.
  function reapplyVariantUrlSelection() {
    if (!new URLSearchParams(window.location.search).has('variant')) return;
    preselectMakeFromVariantUrl(true);

    // preselectMakeFromVariantUrl skips containers where shouldEnableMakeFiltering is false
    // (option1 has no make keywords). For those, VariantAvailability may have reset select
    // values, so we restore them here before applyForContainer re-syncs the custom dropdowns.
    if (!ALL_VARIANTS.length) ALL_VARIANTS = getVariantsFromPage();
    const variantId = new URLSearchParams(window.location.search).get('variant');
    const variant = variantId && ALL_VARIANTS.find(v => String(v.id) === String(variantId));
    if (variant && variant.options) {
      document.querySelectorAll(SELECTORS.makeSelect).forEach(makeSelect => {
        const container = findContainerFromEl(makeSelect);
        if (!container) return;
        const select1 = getFirstVariantSelect(container);
        if (!select1 || shouldEnableMakeFiltering(select1)) return; // already handled above
        const selects = getVariantSelects(container);
        selects.forEach((sel, i) => {
          const optVal = String(variant.options[i] || '');
          if (optVal) sel.value = optVal;
        });
      });
    }

    document.querySelectorAll(SELECTORS.makeSelect).forEach(ms => {
      const container = findContainerFromEl(ms);
      if (container) applyForContainer(container);
    });
    const sticky = getStickyContainer();
    if (sticky) updateStickyUI(sticky);
  }

  // ---------- Init ----------
  function setFirstAvailableVariantInUrl() {
    if (NO_PRESELECT || NO_MAKE_SELECTOR) return;
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (!ALL_VARIANTS.length) return;
    // For motobags: default to first available BMW variant instead of first overall
    const isRackProduct = !!document.querySelector(SELECTORS.makeSelect + '[data-rack-selection]');
    let first;
    if (isRackProduct) {
      first = ALL_VARIANTS.find(v => v.available && textHasMake(String(v.options && v.options[0] || ''), 'BMW'));
    }
    if (!first) first = ALL_VARIANTS.find(v => v.available) || ALL_VARIANTS[0];
    if (!first) return;
    const newUrl = window.location.pathname + '?variant=' + first.id + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }

  function initAll() {
    ALL_VARIANTS = getVariantsFromPage();

    setFirstAvailableVariantInUrl();

    preselectMakeFromVariantUrl();

    // Build custom dropdowns for all selects (make + variant) before applyForContainer runs
    document.querySelectorAll(SELECTORS.makeSelect).forEach(sel => buildCustomDropdown(sel));
    document.querySelectorAll(SELECTORS.variantSelectRaw).forEach(sel => {
      if (isVariantOptionSelect(sel)) buildCustomDropdown(sel);
    });

    // Build rack questions for rack_selection products
    document.querySelectorAll(SELECTORS.makeSelect + '[data-rack-selection]').forEach(function(ms) {
      const container = findContainerFromEl(ms);
      if (container) buildRackQuestion(container);
    });

    // Close open custom dropdowns when clicking outside
    if (!document.__lrCustomDropdownClickBound) {
      document.__lrCustomDropdownClickBound = true;
      document.addEventListener('click', closeAllCustomDropdowns);
    }

    configureStickyVariantUX();

    document.querySelectorAll(SELECTORS.makeSelect).forEach(ms => {
      const container = findContainerFromEl(ms);
      if (container) applyForContainer(container);
    });

    const sticky = getStickyContainer();
    if (sticky) updateStickyUI(sticky);

    initStickyAjaxATC();

    // theme.Variants fires async change events during its own init which can
    // wipe our Make selection. Re-apply 800ms later (after the theme settles)
    // so the configurator is always populated on ?variant= links.
    if (!NO_PRESELECT && !NO_MAKE_SELECTOR) setTimeout(reapplyVariantUrlSelection, 800);

    // Re-enforce ATC disabled state + rebuild initial slider when theme.Variants fires variantChange after make is cleared
    {
      const section = document.querySelector('[data-section-type="product"]');
      if (section) {
        section.addEventListener('variantImageChange', function() {
          const makeSelect = section.querySelector(SELECTORS.makeSelect);
          const select1 = getFirstVariantSelect(section);
          if (makeSelect && select1 && shouldEnableMakeFiltering(select1) && !makeSelect.value) {
            console.log('[LR] variantImageChange fired while make is empty — rebuilding initial slider');
            rebuildInitialSlider(section);
          }
        });
        section.addEventListener('variantChange', function() {
          const makeSelect = section.querySelector(SELECTORS.makeSelect);
          const select1 = getFirstVariantSelect(section);
          if (makeSelect && select1 && shouldEnableMakeFiltering(select1) && !makeSelect.value) {
            setAtcEnabled(section, false);
            const sticky = getStickyContainer();
            if (sticky) setAtcEnabled(sticky, false);
          }
        });
      }
    }

    // For no-make-selector products: intercept variantChange events fired by theme.js
    // and re-enforce ATC disabled state if any option is still unselected.
    if (NO_MAKE_SELECTOR) {
      const section = document.querySelector('[data-section-type="product"]');
      if (section) {
        section.addEventListener('variantChange', function() {
          document.querySelectorAll(SELECTORS.makeSelect).forEach(function(ms) {
            const container = findContainerFromEl(ms);
            if (!container) return;
            const selects = getVariantSelects(container);
            const anyEmpty = selects.some(sel => !sel.value);
            if (anyEmpty && !isStickyContainer(container)) setAtcEnabled(container, false);
          });
        });
      }
    }

    queueMicrotask(() => { __initPhase = false; });
  }

  // ---------- buildForContainer: build custom dropdowns for a specific container ----------
  // Called before theme.sections.register() for quick shop modals so we capture
  // the full option list before VariantAvailability strips native <option> elements.
  function buildForContainer(container) {
    if (!container) return;
    // Use the injected .product-section child if present (covers QuickShopHolder-* case)
    var target = container.querySelector('.product-section') || container;
    var allSelects = target.querySelectorAll('select');
    var makeSelects = target.querySelectorAll(SELECTORS.makeSelect);
    var varSelects = Array.from(target.querySelectorAll(SELECTORS.variantSelectRaw)).filter(isVariantOptionSelect);
    makeSelects.forEach(function(sel) { buildCustomDropdown(sel); });
    varSelects.forEach(function(sel) { buildCustomDropdown(sel); });
  }

  // ---------- initForModal: full Make-filter init for a quick shop modal holder ----------
  // Reads the modal's own variants JSON (not the document-wide sticky/PDP JSON),
  // stores them on holder.__lrVariants so all helper functions use them, then
  // applies Make filtering scoped to this modal. No URL manipulation.
  function initForModal(holder) {
    if (!holder) return;

    // Read variants from THIS modal's textarea — NOT the document-wide sticky JSON
    var jsonEl = holder.querySelector('textarea[data-variant-json]');
    if (!jsonEl) return;
    var modalVariants;
    try { modalVariants = JSON.parse(jsonEl.value || jsonEl.textContent); } catch(e) {
      console.error('[LR initForModal] JSON parse error:', e);
      return;
    }
    if (!modalVariants || !modalVariants.length) return;

    // Store on holder so all helper functions (filterCustomDropdown etc.) pick up the right variants
    holder.__lrVariants = modalVariants;

    // Build rack question if this is a rack_selection product
    var makeSelectInHolder = holder.querySelector(SELECTORS.makeSelect);
    if (makeSelectInHolder && makeSelectInHolder.dataset.rackSelection) {
      buildRackQuestion(holder);
    }

    // Close open custom dropdowns when clicking outside (may not be bound yet on non-PDP pages)
    if (!document.__lrCustomDropdownClickBound) {
      document.__lrCustomDropdownClickBound = true;
      document.addEventListener('click', closeAllCustomDropdowns);
    }

    // The injected product HTML is a .product-section child inside the holder.
    // Use it as the container if available so selectors resolve correctly.
    var productSection = holder.querySelector('.product-section') || holder;

    var makeSelectCheck = productSection.querySelector(SELECTORS.makeSelect);
    var varSelectsCheck = getVariantSelects(productSection);
    var allSelectsCheck = productSection.querySelectorAll('select');
    if (allSelectsCheck.length > 0) {
    }

    // Temporarily use modal variants as global so applyForContainer and its callees work
    var savedVariants = ALL_VARIANTS;
    ALL_VARIANTS = modalVariants;
    try {
      applyForContainer(productSection);
    } finally {
      ALL_VARIANTS = savedVariants;
    }
  }

  // ---------- Event wiring ----------
  let __syncing = false;

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.__lrInternalChange) return;

    const isMake = t.matches(SELECTORS.makeSelect);
    const isVar  = isVariantOptionSelect(t);
    if (!isMake && !isVar) return;


    const container = findContainerFromEl(t);
    if (!container) return;

    // Use modal-specific variants if this change came from inside a quick shop modal
    var savedVars = null;
    var _holder = getModalHolder(t) || getModalHolder(container);
    if (_holder && _holder.__lrVariants) {
      savedVars = ALL_VARIANTS;
      ALL_VARIANTS = _holder.__lrVariants;
    }

    // If a variant select changed and the Make dropdown is still empty,
    // try to infer Make from the ?variant= URL param (handles theme init
    // firing change events before or after our own initAll runs)
    if (isVar && !isMake) {
      const ms = container.querySelector(SELECTORS.makeSelect);
      if (ms && !ms.value) {
        if (!ALL_VARIANTS.length) ALL_VARIANTS = getVariantsFromPage();
        preselectMakeFromVariantUrl();
      }
    }

    if (__syncing) {
      applyForContainer(container);
      if (isStickyContainer(container)) updateStickyUI(container);
      if (savedVars !== null) ALL_VARIANTS = savedVars;
      return;
    }

    applyForContainer(container);

    // re-check sticky UX (make changes can alter how many option selectors matter)
    configureStickyVariantUX();

    const sticky = getStickyContainer();
    if (sticky) updateStickyUI(sticky);

    if (savedVars !== null) ALL_VARIANTS = savedVars;

    if (isStickyContainer(container) && container.__lrSelectVariantsMode) return;

    const other = getOtherContainer(container);
    if (!other) return;
    if (isStickyContainer(other) && other.__lrSelectVariantsMode) return;

    try {
      __syncing = true;

      syncSelectValueByIndex(container, other, t);
      applyForContainer(other);

      if (!isStickyContainer(other)) {
        const s1 = getVariantSelectByIndex(other, 'option1');
        const s2 = getVariantSelectByIndex(other, 'option2');
        const s3 = getVariantSelectByIndex(other, 'option3');
        if (s1) dispatchChange(s1);
        if (s2) dispatchChange(s2);
        if (s3) dispatchChange(s3);
      }

      const sticky2 = getStickyContainer();
      if (sticky2) updateStickyUI(sticky2);

    } finally {
      __syncing = false;
    }
  });

  // Pre-populate ALL_VARIANTS so buildCustomDropdown can supplement any options already
  // stripped by VariantAvailability (theme.js). If theme.js deferred before this script,
  // VariantAvailability may have already removed unavailable <option> elements.
  if (!ALL_VARIANTS.length) ALL_VARIANTS = getVariantsFromPage();

  // Build custom dropdowns synchronously as soon as this script executes.
  document.querySelectorAll(SELECTORS.makeSelect).forEach(sel => buildCustomDropdown(sel));
  document.querySelectorAll(SELECTORS.variantSelectRaw).forEach(sel => {
    if (isVariantOptionSelect(sel)) buildCustomDropdown(sel);
  });

  document.addEventListener('variant:change', function(e) {
    if (!ALL_VARIANTS || !ALL_VARIANTS.length) return;
    var detail = e.detail;
    if (!detail || !detail.currentlySelectedValues) return;

    var selectedByIndex = {};
    detail.currentlySelectedValues.forEach(function(o) {
      selectedByIndex[o.index] = o.value;
    });


    var containers = Array.from(document.querySelectorAll('[data-section-type="product"]'));
    var sticky = getStickyContainer();
    if (sticky) containers.push(sticky);

    containers.forEach(function(container) {
      var selects = getVariantSelects(container);

      // Use modal-scoped variants if this container is inside a quick shop holder
      var savedVars = null;
      var holder = getModalHolder(container);
      if (holder && holder.__lrVariants) {
        savedVars = ALL_VARIANTS;
        ALL_VARIANTS = holder.__lrVariants;
      }

      for (var i = 1; i < selects.length; i++) {
        var sel = selects[i];
        if (selectContainsMakeKeywords(sel)) continue;
        var priorVals = [];
        for (var j = 0; j < i; j++) {
          priorVals.push(selectedByIndex['option' + (j + 1)] || selects[j].value);
        }
        filterCustomDropdownByPriorSelections(sel, i + 1, priorVals);
      }

      if (savedVars !== null) ALL_VARIANTS = savedVars;
    });
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  // ---------- Public API for quick shop modal support ----------
  window.__lrMakeFilter = {
    buildForContainer: buildForContainer,
    initForModal: initForModal
  };

})();
